export enum RouteKeys {
  List = '/admin-user',
  New = '/admin-user/new',
  Edit = '/admin-user/:id',
}
